const messages = {
    buttons: {
        productBrochures: "Descoperă",
    },
    index: {
        title: "INFORMAȚII DESPRE PRODUS",
        description: "Descărcați aici cele mai recente broșuri și flyere ale anvelopelor noastre Bridgestone și Firestone.",
        categories: {
            productBrochures: {
                title: "Broșuri produse",
                description: "Broșuri ale gamei de anvelope Bridgestone și Firestone",
            },
            bDrive: {
              title: "Imagini produse",
              description: "Imaginile actuale pot fi descărcate din portalul nostru B-DRIVE.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

